import { useMemo } from "react";

const HEADERS = [
  "description du poste", "caractéristiques du poste", "caracteristiques du poste",
  "principaux enjeux", "éléments de contexte", "elements de contexte", "éléments de contexte spécifiques",
  "savoir-être", "savoir-etre", "savoir-faire", "expériences", "experiences",
  "expériences/connaissances recherchées", "connaissances recherchées", "connaissances recherchees",
  "profil recherché", "profil recherche", "votre profil", "vos missions", "missions",
  "compétences", "competences", "rémunération", "remuneration", "avantages",
  "responsabilités", "responsabilites", "environnement technique", "contexte",
];

const esc = (s) => s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");

function segment(raw) {
  if (!raw) return [];
  // Certaines sources stockent les retours à la ligne en littéral ("\n", "\r\n") au lieu de vrais
  // sauts de ligne : on les décode d'abord, sinon toute la description s'affiche en un seul bloc.
  let t = raw
    .replace(/\\r\\n/g, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\\t/g, " ")
    .replace(/\r\n/g, "\n").replace(/\r/g, "\n").trim();

  // Fallback: descriptions ingested without line breaks — inject structure heuristically.
  if (!t.includes("\n")) {
    t = t.replace(/\s+(\d{1,2}\.\s(?=[A-ZÉÀÂÎÔ]))/g, "\n$1"); // numbered sections
    t = t.replace(/\s+-\s+/g, "\n- ");                          // " - " bullets
    for (const h of HEADERS) {
      t = t.replace(new RegExp("\\s+(" + esc(h) + ")(\\s*:)?", "gi"), "\n$1$2");
    }
  }

  const lines = t.split("\n").map((l) => l.trim()).filter(Boolean);
  const blocks = [];
  let list = null;
  for (const line of lines) {
    const isBullet = /^[-•*]\s?/.test(line);
    if (isBullet) {
      const clean = line.replace(/^[-•*]\s?/, "").trim();
      if (clean) {
        if (!list) { list = { type: "list", items: [] }; blocks.push(list); }
        list.items.push(clean);
      }
      continue;
    }
    list = null;
    const lower = line.toLowerCase().replace(/\s*:\s*$/, "").trim();
    const isNum = /^\d{1,2}\.\s/.test(line);
    const isHeader = isNum || HEADERS.includes(lower) || (line.length < 64 && /:\s*$/.test(line));
    if (isHeader) blocks.push({ type: "header", text: line.replace(/\s*:\s*$/, "").trim() });
    else blocks.push({ type: "p", text: line });
  }
  return blocks;
}

export default function JobDescription({ text, testid }) {
  const blocks = useMemo(() => segment(text), [text]);
  if (!blocks.length) return <p className="text-sm text-fg/70">—</p>;
  return (
    <div className="space-y-2.5 text-sm text-fg/90 leading-relaxed" data-testid={testid}>
      {blocks.map((b, i) => {
        if (b.type === "header")
          return <div key={i} className="font-display font-semibold text-fg text-[0.95rem] mt-4 first:mt-0">{b.text}</div>;
        if (b.type === "list")
          return (
            <ul key={i} className="space-y-1.5">
              {b.items.map((it, j) => (
                <li key={j} className="flex gap-2.5"><span className="text-accent mt-1 text-[0.6rem] shrink-0">▸</span><span>{it}</span></li>
              ))}
            </ul>
          );
        return <p key={i}>{b.text}</p>;
      })}
    </div>
  );
}
